'use client';

import { FC } from 'react';

interface INoContentProps {
  message?: string;
}

export const NoContent: FC<INoContentProps> = ({
  message = 'No content available',
}) => {
  return (
    <div className="flex h-[50vh] w-full items-center justify-center">
      <p className="text-lg text-gray-500">{message}</p>
    </div>
  );
};
